import * as types from '../_actions/actionTypes'
import _ from 'lodash'

export function templates(state = {}, action) {
    switch (action.type) {
        case types.FETCH_TEMPLATES:
            return {
                ...state,
                ...action.payload,
            }
        case types.FETCH_TEMPLATES_FAILURE:
            return state
        case types.UPDATE_TEMPLATES:
            return _.merge({}, state, action.payload)
        case types.UPDATE_TEMPLATES_FAILURE:
            return state
        case types.REMOVE_TEMPLATE:
            return { templates: _.omit(state.templates, action.payload) }
        case types.REMOVE_TEMPLATE_FAILURE:
            return state
        default:
            return state
    }
}
